export default {
  type: "locations",
  name: null,
  redirect: null,
  excerpt: "",
  relationshipNames: ["organization", "manager", "contacts"],
  organization: {
    type: "organizations",
    id: null,
  },
  manager: {
    type: "users",
    id: null,
  },
  contacts: [],
};
